import { scan } from "react-scan";

// IMPORTANT: `scan()` must be imported and executed before `react`/`react-dom`
// so React Scan can hijack React DevTools early.
scan({
  enabled: import.meta.env.DEV,
  showToolbar: import.meta.env.DEV,
  // Reduces animation overhead/visual noise when you are tuning re-render frequency.
  animationSpeed: "off",
});

// Base UI: skip JS animation completion tracking (Firefox "dead object" on detached popups).
globalThis.BASE_UI_ANIMATIONS_DISABLED = true;

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@/index.css";

import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "@/routeTree.gen";
import { bindMatomoToRouter, initMatomoTracker } from "@/lib/matomo/tracker";
import { DatabaseProvider } from "@/tanstack-db/DatabaseProvider";
import { queryClient } from "@/tanstack-db/query-client";

const router = createRouter({
  routeTree,
  context: { queryClient },
});

initMatomoTracker();
bindMatomoToRouter(router);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <DatabaseProvider>
      <RouterProvider router={router} />
    </DatabaseProvider>
  </StrictMode>
);
